import { TextField, Autocomplete } from '@mui/material';
import useCountries from 'entities/geo/countries/countries.hook';
import { TextFieldProps, fieldToTextField } from 'formik-mui';
import { ICountry } from 'interfaces/ICountry';
import { SyntheticEvent, useCallback, useEffect, useState } from 'react';

interface CountryPickerProps extends TextFieldProps {
  onCountryChange?: (value: string | null) => void;
}

export const CountryPicker = (props: CountryPickerProps) => {

  const {
    onCountryChange,
    ...restProps
  } = props;
  const {
    form: { setFieldValue },
    field: { name, value },
    label
  } = restProps;

  const [open, setOpen] = useState(false);
  const { list, loading: fetching } = useCountries(open || Boolean(value));
  const [selectedCountry, setSelectedCountry] = useState<ICountry | null>(null); 

  const onChange = useCallback(
    (_event: SyntheticEvent<Element, Event>, newValue: ICountry | null) => { 
      setSelectedCountry(newValue);
      const countryId = newValue?.id?.toString() || null;
      setFieldValue(name, countryId);
      
      if (onCountryChange) {
        onCountryChange(countryId);
      }
    },
    [setFieldValue, name, setSelectedCountry, onCountryChange]
  );

  useEffect(() => {
    setSelectedCountry(list.find(x => x.id?.toString() === value?.toString()) ?? null);
  }, [list, value]);

  const loading = open && list.length === 0 && fetching;

  return (
    <Autocomplete
      value={selectedCountry}
      autoComplete={false}
      options={list}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      onChange={onChange}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => `${option.name}`}
      loading={loading}
      loadingText={'Загрузка...'}
      noOptionsText={'Ничего не найдено'}
      renderInput={
        (params) => <TextField
          {...fieldToTextField(restProps)}
          {...params}
          name={name}
          label={label}
          placeholder="Начните набирать..." />
      }
    />
  );
};